

(function timePicketModule() {

    angular.module('TimePicker', ['Popup', 'ui.bootstrap.timepicker']);

})();